const LoyaltyCouponReportModule = () => import('./LoyaltyCouponReportModule.vue')
const CouponsReportIndex = () => import('./views/CouponReportIndex.vue')

export const loyaltyCouponsReportRoute = {
  path: '/report/loyalty',
  component: LoyaltyCouponReportModule,
  meta: {
    title: 'LoyaltyCouponsReport',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: 'coupons',
      name: 'loyalty-coupons-report',
      meta: {
        permission: 'loyalty_coupon.view_all',
      },
      component: CouponsReportIndex,
    },
  ],
}
